import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useState, useEffect, useLayoutEffect, Profiler, useMemo } from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { getAsset } from 'api/getAsset'
import { getOrgInfo } from "api/organisation";
import { BASE_URL } from "constants/routes";

import FormStepper from "components/FormStepper";

import { ButtonV1, Image } from "lib";

import client_logo from "assets/images/kotak_mahindra_bank_formdisplay.svg"
import Signdesk_logo from "assets/images/signdesk_logo.svg"

import "./index.scss";
import { updateWorkflowInfo } from "api/formDisplay";
import { setPrimaryWorkflowId, setShowAccountList, setSwitchProfile } from "redux/conditionalRendering";
import { setPrimaryUser } from "redux/userInfo";
import { clearSaveData, clearShowData } from "redux/recursiveReducer";
import { createUserWorkflowPayload } from "helper/createPayload";
import { clearConfiguration } from "redux/configurationReducer";
import { getConfiguration } from "api/configuration";
import { setStepperDisplay } from "redux/stepperReducer";
import Toast from "components/ToastComponent";
import { removeSaveAsDraft, setShowSaveAsDraft } from "redux/popupReducer";
import { saveDraft } from "api/saveDraft";
import { encryptUrl } from "api/UrlEncryption";
import { handleEmailNotification } from "helper/callbacks";
import adgmLogo from "assets/images/kotak_logo_adgm.svg"
import LoadingSpinner from "lib/LoadingSpinner";
import { setLogoUrl } from "redux/urlEncryption";
import UploadSpinner from "lib/uploadSpinner";
import { getAllSignerId, setAppColor } from "helper";
import { cleardeleteDocument } from "redux/uploadDocumentReducer";
import { ProgressBar, Nav, Row, Col, Container, Navbar } from "react-bootstrap";
import Sign_desk_logo from "assets/images/signdesk_logo.svg"
import { UAE_PASS_ROUTE } from "constants/routes";

const Layout = (props) => {
  const { children,
    landing = false,
    nav_orientation,
     config,
    selectedData,
    consent,
    banner,
    removeLeftMargin,
    formErr,
    custom_style,
    setFormErr,
    allignment_position,
    validateAndSubmit,
    organisation,
   } = props;
  const navigate = useNavigate()
  const params = useParams()
  const dispatch = useDispatch()
  const primaryUser = useSelector(state => state.userInfo?.primaryUser)
  const saveData = useSelector(state => state.recursive?.saveData)
  const formFields = useSelector(state => state.recursive?.formFields)
  const arrayName = useSelector(state => state.recursive.arrayName)
  const wfConfig = useSelector(( state) => state?.configurationReducer?.config);
  const uploadedDocument = useSelector(state => state.uploadDocumentReducer?.uploadedDocument)
  const documents = useSelector(state => state.uploadDocumentReducer?.documents)
  const deleteDocument = useSelector(state => state.uploadDocumentReducer?.deleteDocument)
  const selectedQuestion = useSelector(state => state.formData?.selectedQuestion)
  const questionnaireId = useSelector(state => state.formData?.questionnaireId)
  const questionData = useSelector(state => state.formData?.questionData)
  const activeSection = useSelector((state) => state.userInfo.activeSection);
  const showSaveAsDraft = useSelector((state) => state?.popupReducer?.showSaveAsDraft);
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId)
  const workflowUser = useSelector((state) => state.userInfo?.workflowUser)
  const isSignerRecursion = useSelector((state) => state.recursive?.isSignerRecursion);
  const logoUrl = useSelector((state) => state.urlEncryption?.logoUrl)
  const wfName = useSelector(state => state.configurationReducer.config.organisation_id)
  const loading = useSelector((state) => state.configurationReducer?.loading);
  const uploadLoading = useSelector((state) => state.configurationReducer?.uploadLoading);
  const form_occupancy = useSelector(
    (state) => state.stepperReducer?.formOccupancy
  );
  const paymentDetails = useSelector((state) => state.paymentReducer?.payment_details);
  const logout_required = useSelector((state)=> state?.userInfo?.primaryUser?.uae_pass_callback_response);
 
  const [showProfile, setShowProfile] = useState(false)
  const [profileName, setProfileName] = useState("")
  const [colorCode, setColorCode] = useState('')
  const [isMobile, setIsMobile] = useState(false);
  const [poweredBy, setPoweredBy] = useState(false);

  let profile = [];

  const search = window.location.search;
  const query = new URLSearchParams(search);

  const requestedId = useMemo(() => {
    return query.get("requestedId");
  }, [search]);
  const tokenForRequestedDoc = useMemo(() => {
    return query.get("token");
  }, [search]);

  let subworkflow = primaryUser?.source_data?.subworkflows;
  let signin_link = subworkflow?.find((data) => data)?.link;
  let configurationId = primaryUser?.configuration_id
  subworkflow?.map(item => {
    let dataObj = {}, fullName

    fullName = subworkflow?.length > 1 ?  item?.full_name.slice(3) : item?.full_name
    dataObj.name = fullName
    dataObj._id = item?._id
    dataObj.configurationId = configurationId
    dataObj.userId = item?.user_id
    profile.push(dataObj);
  })


  useEffect(() => {
    checkWindowWidth()
    const root = document.documentElement;
    if (form_occupancy) {
      root.style.setProperty('--form-width', `${form_occupancy}`)
    }
    if (decryptedId || paymentDetails)
      if(wfConfig?.logo){
        dispatch(setLogoUrl("https://signdesk.in/company/" + wfConfig?.logo));
        const list = document.getElementById('favicon_customized');
        list.href = wfConfig?.icon ? `https://signdesk.in/company/${wfConfig?.icon}` : 'https://signdesk.com/images/favicon.png';
        const titleName = document.getElementById('title-id');
        titleName.innerText =wfConfig?.parent_client_name || "loading...";
        setAppColor(wfConfig?.layout_setting)
      }else{
        getOrgInfo({ _id: wfName || organisation }).then((res) => {
          setPoweredBy(res?.white_labeled ? res?.white_labeled : false);
          if(res?.logo){
            dispatch(setLogoUrl("https://signdesk.in/company/" + res?.logo));
          }
          const list = document.getElementById('favicon_customized');
          list.href = res?.icon ? `https://signdesk.in/company/${res?.icon}` : 'https://signdesk.com/images/favicon.png';
          const titleName = document.getElementById('title-id');
          titleName.innerText = res?.setting?.parent_client_name || "loading...";
          setAppColor(res?.layout_setting)
        })
      }
  }, [])



  useEffect(() => {
    dispatch(removeSaveAsDraft())
    if (Object.keys(primaryUser)?.length) {
      //TODO:- Write this condition in the config and fetch it from there. Where in the config?
      // if (subworkflow?.length > 1) {
        primaryUser.source_data?.subworkflows.forEach(item => {
          if (item?._id == decryptedId?.subWfId) {
            setShowProfile(true)
            let profileColor = item.profile_color_code
            let firstInitial = item?.first_name ? item?.first_name?.trim().charAt(0) : ''
            let secondInitial = item?.last_name ? item?.last_name?.trim().charAt(0) : ''
            let initials = firstInitial + secondInitial
            setProfileName(initials)
            setColorCode(profileColor)
            return
          }
        })
      // }
    }
  }, [primaryUser])

  const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo);
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;



  const handleRedirect = async (param) => {
    const { configurationId, userId: applicant_id } = param
    // console.log("coming in handle redirect");
    let primaryWorkflowId = params?.primaryWorkflowId
    let userId = loggedUserId ? applicant_id : params?.userId;
    const user_id = loggedUserId ? await encryptUrl(userId) : userId;

    dispatch(setPrimaryWorkflowId(primaryWorkflowId))
    dispatch(setShowAccountList(true))
    dispatch(setSwitchProfile(true))
    dispatch(clearConfiguration())
    dispatch(getConfiguration(configurationId))
    dispatch(setStepperDisplay(false))
    // navigate("/update-successful")
    navigate(`/formSubmission/${primaryWorkflowId}/${user_id}`)
    window.location.reload(true)
    //window.close()
  }

  // const handleDraftChange = () => {
  //   let params={
  //     organisation_id:selectedData.organisation_id,
  //      recipientEmail:workflowUser.subworkflows.email,
  //      trigger:"saveDraft",
  //      recipientName:workflowUser.subworkflows.full_name,
  //      link:workflowUser.subworkflows.link
  //   }
  //   dispatch(saveDraft(params))
  //     handleAutoSave()
  // }

  const handleDraftChange = () => {
    let recipientEmailid, recipientName, subworkflowsData = primaryUser?.source_data?.subworkflows, flag = true
    subworkflowsData?.map((item, index) => {
      if (flag && item.user_id == decryptedId.userId) {
        recipientEmailid = item.email
        if (item?.last_name) {
          recipientName = item?.first_name + " " + item?.last_name;
        } else recipientName = item?.first_name
        flag = false
      }

    })
    if (flag && loggedInUserInfo?.profileInfo) {
      recipientEmailid = loggedInUserInfo?.profileInfo?.emailId
      recipientName = loggedInUserInfo?.profileInfo?.role_name
    }
    handleAutoSave()
    let url = new URL(workflowUser.subworkflows.link);
    url?.searchParams?.delete("authType");
    let cleanedLink = url.origin + url.pathname;
    let params = {
      organisation_id: selectedData.organisation_id,
      to: recipientEmailid,
      from: "Kotak Bank <support@signdesk.com>",
      trigger: flag ? "rmSaveDraft" : "saveDraft",
      recipientName: recipientName,
      link: cleanedLink || workflowUser.subworkflows.link ,
      status: selectedData.status,
      active_step: selectedData.active_step,
      company: selectedData?.company || "",
      application_ref_id : selectedData?.application_ref_id
    };
    // dispatch(saveDraft(params))
    // let callback = { params, trigger: params.trigger}
    handleEmailNotification(params)
  }

  // Auto Saving feature
  // useEffect(() => {
  //   // Condition to enable auto save only for dynamic forms and not conditional redirection
  //   if (params.subWfId) {
  //     const interval =  setInterval(()=>{ handleAutoSave() }, 30000);
  //     return () => clearInterval(interval);
  //   }
  // }, [selectedData])


  const handleAutoSave = () => {
    let payload
    let formattedData = { ...selectedData }
    dispatch(removeSaveAsDraft())
    let signer_data = []

    if (saveData && saveData.length) {
      let fieldNames = formFields.map((item, index) => {
        return item.name
      })

      fieldNames?.map(item => {
        delete formattedData[item]
      })

      if (isSignerRecursion) {
        signer_data = getAllSignerId(config?.wf_journey[0]?.form_structure?.sections)
      }
      let isRecursiveData = 'true';
      let recursiveData = {}
      recursiveData[arrayName] = saveData
      dispatch(clearSaveData())
      dispatch(clearShowData())
      payload = createUserWorkflowPayload(formattedData, recursiveData, uploadedDocument, selectedQuestion, questionData, questionnaireId, isSignerRecursion, signer_data, documents, deleteDocument, null, isRecursiveData)
    } else {
      payload = createUserWorkflowPayload(formattedData, null, uploadedDocument, selectedQuestion, questionData, questionnaireId, isSignerRecursion, signer_data, documents, deleteDocument)
    }
    if (payload) {
      let formattedpayload = {
        ...payload,
        userId: decryptedId.subWfId
      }
      dispatch(updateWorkflowInfo(formattedpayload))
        .then((res) => {
          if (res?.meta?.requestStatus === "fulfilled") {
            // Update the state to 'success' if the API call was successful
            dispatch(setShowSaveAsDraft('success'))

          }
        })
        .catch((error) => {
          // Update the state to 'error' if the API call failed
          dispatch(setShowSaveAsDraft('error'))
          console.error(error);
        });
      dispatch(cleardeleteDocument())
    }
  }

  const checkWindowWidth = () => {
    const width = window.innerWidth;
    if (width < 640 && !isMobile) {
      // // console.log("false", width);
      setIsMobile(true);
    } else if (width > 640 && isMobile) {
      setIsMobile(false);
      // // console.log("true", width);
    }
  };


  const handleLogout = () => {
    const fullURL = window.location.href;
    const url = new URL(fullURL);
    const segments = url.pathname.split("/");
    const baseURL = `${url.protocol}//${url.host}/${segments[1]}`;
    const navigationLink = "/update-successful";
    // let navUrl = `${baseURL}${navigationLink}`;
    window.location.href = `${UAE_PASS_ROUTE}/logout?redirect_url=${signin_link}`;
  }

  window.addEventListener("resize", () => checkWindowWidth());

  //  removing this because its affecting the validation and user interface
  // useEffect(()=>{
  //   // console.log(formErr);
  //   const container = document.querySelector('#container');
  //   if(formErr && Object.keys(formErr).length !== 0 ){
  //     container.scrollTo({top:0, behavior:'smooth'});
  //   }
  // },[formErr])

  // adith predenting this well fine  
  // useEffect(()=>{
  //   // console.log(formErr);
  //   const container = document.querySelector('#container');
  //   if(formErr && Object.keys(formErr).length !== 0 ){
  //     container.scrollTo({top:0, behavior:'smooth'});
  //   }
  // },[formErr])

  if (loading) {
    return <LoadingSpinner />;
  }
  let userCount = 0;
  return (
    <div className="bg-forms bg-cover bg-no-repeat bg-mobile">
      <Navbar className="nav-border position-sticky top-0 bg-sm-white z-index-9">
        <Row className="justify-content-between align-items-center py-0 mx-2 mx-lg-2 w-100">
          <Col xs={5} md={2} lg={2}>
            <Image imageSrc={logoUrl || ""} className="w-100 h-25" />
          </Col>
          <Col md={3} lg={3} className="d-none d-md-block">
            <div className="d-flex align-items-center justify-content-end">
              {showProfile && (
                <Dropdown as={ButtonGroup}>
                  <Dropdown.Toggle
                    className="rounded-circle h-45px w-45px d-flex align-items-center justify-content-center border-0 me-3"
                    style={{ backgroundColor: colorCode }}
                  >
                    {profileName}
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                      </svg>
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu show={false} className="pb-0 overflow-hidden">
                    {profile &&
                      profile.map((items) =>  {
                        userCount = userCount + 1
                        return (
                          <>
                        <Dropdown.Item
                          disabled={items?._id == decryptedId?.subWfId}
                          onClick={() => {
                            handleRedirect(items);
                          }}
                        >
                          {items.name ? items.name : `User  ${userCount }` }
                        </Dropdown.Item>
                        {
                          logout_required &&
                        <Dropdown.Item className="p-0">
                          <div className="bg-theme-grey border-top border-2 px-0 d-flex py-2" >
                                      <div className="mx-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
            <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
          </svg></div>
                            <div  onClick={handleLogout}
                            >Logout</div>
                          </div>
                      </Dropdown.Item>
                        }
                          </>
                        )
                      })}
                  
                  </Dropdown.Menu>
                </Dropdown>
              )}
              {!landing && (
                <div>
                  <ButtonV1
                    label="Save as draft"
                    className="btn bg-transparent text-theme fs-14px fw-bold border border-2 border-theme draft-btn"
                    disabled={requestedId || tokenForRequestedDoc}
                    onClick={handleDraftChange}
                  />
                </div>
              )}
    
          </div>
          </Col>
        </Row>
        <div className="d-sm-none d-xs-block me-3 ps-2 border-start d-none">
          <span className="">

<svg xmlns="http://www.w3.org/2000/svg" width="28.242" height="29.671" viewBox="0 0 28.242 29.671">
  <g id="Group_1669" data-name="Group 1669" transform="translate(-17 -16.103)">
    <g id="Group_1667" data-name="Group 1667" transform="translate(20.815 16.103)">
      <path id="Path_708" data-name="Path 708" d="M87.567,226.976a10.682,10.682,0,0,0-.2-1.559,10.431,10.431,0,0,0-7.2-7.878L83.5,227.5s-5.051,3.019-5.682,7.114H77.4v-7.635a1.514,1.514,0,0,0,1.359-1.46,1.592,1.592,0,0,0-3.176,0,1.513,1.513,0,0,0,1.362,1.46v7.635h-.414c-.627-4.1-5.681-7.114-5.681-7.114l3.365-9.968a10.416,10.416,0,1,0,13.151,12.088,10.687,10.687,0,0,0,.2-1.563c.006-.176.013-.355.013-.537s-.007-.357-.013-.54" transform="translate(-66.77 -217.101)" fill="#71a350"/>
      <path id="Path_709" data-name="Path 709" d="M96.4,232.527h.414v-7.635a1.513,1.513,0,0,1-1.362-1.46,1.592,1.592,0,0,1,3.176,0,1.514,1.514,0,0,1-1.359,1.46v7.635h.412c.631-4.1,5.682-7.114,5.682-7.114l-3.331-9.958a10.429,10.429,0,0,0-5.948-.01l-3.365,9.968s5.054,3.019,5.681,7.114" transform="translate(-86.636 -215.017)" fill="#fff"/>
    </g>
    <g id="Group_1668" data-name="Group 1668" transform="translate(17 39.98)">
      <path id="Path_710" data-name="Path 710" d="M206.851,238.819a.944.944,0,0,0,.972.661c.552,0,.888-.276.888-.643,0-.33-.276-.535-.618-.661l-.63-.216c-.828-.27-.972-.757-.972-1.124a1.232,1.232,0,0,1,1.35-1.16,1.3,1.3,0,0,1,1.374,1l-.54.162a.773.773,0,0,0-.834-.619c-.4,0-.744.222-.744.607,0,.18.054.415.546.6l.636.24a1.266,1.266,0,0,1,1.02,1.13c0,.745-.588,1.22-1.464,1.22a1.49,1.49,0,0,1-1.548-1.052Z" transform="translate(-206.287 -235.568)" fill="#404751"/>
      <path id="Path_711" data-name="Path 711" d="M268.132,233.992a.4.4,0,0,1,.408.409.4.4,0,0,1-.408.4.4.4,0,0,1-.4-.4.4.4,0,0,1,.4-.409m.294,1.376h-.582v3h.582Z" transform="translate(-263.781 -233.992)" fill="#404751"/>
      <path id="Path_712" data-name="Path 712" d="M297.594,257.424a1.408,1.408,0,0,1-1.566,1.436,1.865,1.865,0,0,1-1.284-.433l.234-.457a1.551,1.551,0,0,0,1.05.379.9.9,0,0,0,.984-.98v-.4a1.26,1.26,0,0,1-1.086.547,1.571,1.571,0,0,1,0-3.137,1.26,1.26,0,0,1,1.086.547v-.481h.582Zm-1.6-2.53a1.054,1.054,0,0,0,0,2.1,1.052,1.052,0,0,0,0-2.1" transform="translate(-288.772 -253.067)" fill="#404751"/>
      <path id="Path_713" data-name="Path 713" d="M364.766,255.752c0-.637-.294-.859-.612-.859a1.013,1.013,0,0,0-.966,1.16v1.394h-.582v-3h.582v.6a.977.977,0,0,1,1.008-.667c.648,0,1.152.409,1.152,1.376v1.695h-.582Z" transform="translate(-352.559 -253.066)" fill="#404751"/>
      <path id="Path_714" data-name="Path 714" d="M426.975,240.911h-1.338v-4.206h1.338a2.1,2.1,0,1,1,0,4.206m0-3.714h-.738v3.221h.738a1.612,1.612,0,0,0,0-3.221" transform="translate(-411.54 -236.531)" fill="#404751"/>
      <path id="Path_715" data-name="Path 715" d="M495.784,256.955a1.686,1.686,0,0,1-1.314.559,1.571,1.571,0,1,1-.078-3.137,1.483,1.483,0,0,1,1.53,1.623h-2.563a1,1,0,0,0,1.116,1,1.459,1.459,0,0,0,.984-.379Zm-2.371-1.406h1.908a.88.88,0,0,0-.918-.661,1,1,0,0,0-.99.661" transform="translate(-474.365 -253.067)" fill="#404751"/>
      <path id="Path_716" data-name="Path 716" d="M553.712,255.206a.449.449,0,0,0-.468-.331.4.4,0,0,0-.444.385c0,.2.18.3.36.361l.432.144a.862.862,0,0,1,.72.847.964.964,0,0,1-1.08.9,1.132,1.132,0,0,1-1.158-.787l.516-.126a.66.66,0,0,0,.648.415c.3,0,.516-.174.516-.409,0-.2-.168-.306-.378-.379l-.4-.138c-.48-.144-.738-.4-.738-.817a.908.908,0,0,1,.99-.9.968.968,0,0,1,1,.715Z" transform="translate(-529.852 -253.067)" fill="#404751"/>
      <path id="Path_717" data-name="Path 717" d="M603.928,235.893h.648v.066l-1.1,1.316.51.775c.174.246.258.4.528.4a.643.643,0,0,0,.39-.114l.2.391a.893.893,0,0,1-.654.234,1.089,1.089,0,0,1-.948-.637l-.606-.974V238.9h-.582v-4.345h.582v2.6Z" transform="translate(-576.863 -234.517)" fill="#404751"/>
    </g>
  </g>
</svg>

          </span>
        </div>
      </Navbar>

      <Container fluid>
        <Row className={`my-1 ${custom_style === 'd-none' ? 'justify-content-center':''} ${nav_orientation === 'horizontal' ? '' : 'flex-column align-items-center'} `}>
          <Col xs={12} className={`d-md-none ${custom_style}`}>
            <div className="d-flex align-items-center justify-content-end justify-content-md-between">
              {showProfile && (
                <Dropdown as={ButtonGroup}>
                  <Dropdown.Toggle
                    className="rounded-circle h-45px w-45px d-flex align-items-center justify-content-center border-0 me-3 z-index-0 "
                    style={{ backgroundColor: colorCode }}
                  >
                    {profileName}
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                      </svg>
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu show={false}>
                    {profile &&
                      profile.map((items) => (
                        <Dropdown.Item
                          disabled={items?._id == decryptedId?.subWfId}
                          onClick={() => {
                            handleRedirect(items);
                          }}
                        >
                          {items.name}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}
              {!landing && (
                <div>
                  <ButtonV1
                    label="Save as draft"
                    className="btn btn-secondary btn-theme draft-btn"
                    disabled={requestedId || tokenForRequestedDoc}
                    onClick={handleDraftChange}
                  />
                </div>
              )}
          </div>
          </Col>
          <Col xs={12} md={4} lg={nav_orientation === 'horizontal' ? 5 : 12} className={`${custom_style}`}>
            <Row className={`d-block d-md-flex justify-content-center pe-lg-0 ${nav_orientation === 'horizontal' ? 'justify-content-md-end' : ''}`}>
              <Col xs={12} md={12} lg={nav_orientation === 'horizontal' ? 7 : 12} className="pe-lg-0">
                <FormStepper
                  nav_orientation={nav_orientation}
                  config={config}
                  consent={consent}
                  banner={banner}
                  isMobil={isMobile}
                  formErr={formErr}
                  setFormErr={setFormErr}
                  validateAndSubmit={validateAndSubmit}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={8} lg={nav_orientation === 'horizontal' ? '7' : '12'}>
            <Row className={`my-md-0 py-lg-3 ${nav_orientation === 'horizontal' ? '' : 'justify-content-center'} ${custom_style === 'd-none' ? 'justify-content-center':''}`}>
              <Col xs={12} md={12} lg={9} className={`z-index-1 pt-1 form-width bg-white p-3 pb-0 pb-md-4 p-lg-4 py-3 py-md-3 px-4 rounded-3 shadow-lg bg-sm-transparent shadow-sm-none position-relative ${nav_orientation === 'horizontal' ? 'form-container-height' : ''} overflow-auto theme-scrollbar`} id="dynamic_form_container">
                <Row className="gy-1 mt-0 rounded">
                  {children}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      {showSaveAsDraft && showSaveAsDraft !== "" && (
                <Toast
                
                  message={
                    showSaveAsDraft === "success"
                      ? "Your data has been saved successfully!"
                      : "Failed to save "
                  }
                  type={showSaveAsDraft || "success"}
                />
      )}
      {poweredBy && (
        <div className='signdesk_logo px-2'>
          <p>Powered by</p>
          <Image imageSrc={Sign_desk_logo} alt="signDesk_logo" />
        </div>
      )}
    </div>
  );
};

export default Layout;
